<template>
  <div class="tsf">
    <button
      v-for="t in options"
      :key="t.id"
      class="tsf__card"
      :class="{ 'tsf__card--active': modelValue === t.id }"
      @click="$emit('update:modelValue', t.id)"
    >
      <span class="tsf__avatar" :style="{ background: AVATAR_COLORS[t.avatarColor] || t.avatarColor }">{{ initials(t.name) }}</span>
      <div class="tsf__info">
        <div class="tsf__name">{{ t.name }}</div>
        <div class="tsf__count">
          {{ t.activeTicketCount }} tickets activos
          <span v-if="t.acceptingTickets === false" class="tsf__pause" title="Marcó que no acepta tickets por ahora">· En pausa</span>
        </div>
        <div class="tsf__bar"><div class="tsf__bar-fill" :class="capacityClass(t.capacityPercent)" :style="{ width: t.capacityPercent + '%' }"></div></div>
      </div>
      <span v-if="modelValue === t.id" class="mdi mdi-check-circle tsf__check"></span>
    </button>
  </div>
</template>

<script setup>
defineProps({ modelValue: { type: String, default: null }, options: { type: Array, default: () => [] } })
defineEmits(['update:modelValue'])

const AVATAR_COLORS = { blue: '#3b82f6', green: '#10b981', violet: '#8b5cf6', orange: '#f97316', teal: '#14b8a6', pink: '#ec4899', indigo: '#6366f1', amber: '#f0a500' }
function initials(name) { return name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase() }
function capacityClass(pct) { return pct >= 85 ? 'tsf__bar-fill--red' : pct >= 60 ? 'tsf__bar-fill--amber' : 'tsf__bar-fill--green' }
</script>

<style scoped>
.tsf { display: flex; flex-direction: column; gap: 0.4rem; }
.tsf__card { display: flex; align-items: center; gap: 0.5rem; background: #f8f9fc; border: 1px solid transparent; border-radius: 6px; padding: 0.5rem; height: 44px; box-sizing: border-box; cursor: pointer; text-align: left; }
.tsf__pause { color: #b45309; font-weight: 600; }
.tsf__card--active { border-color: #3b82f6; }
.tsf__avatar { width: 28px; height: 28px; border-radius: 50%; color: #ffffff; font-size: 10px; font-weight: 600; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.tsf__info { flex: 1; min-width: 0; }
.tsf__name { font-family: var(--font-body); font-size: 12px; font-weight: 500; color: #1e3a5f; }
.tsf__count { font-family: var(--font-body); font-size: 10px; color: #94a3b8; }
.tsf__bar { height: 4px; background: #e2e8f0; border-radius: 2px; margin-top: 0.15rem; overflow: hidden; }
.tsf__bar-fill { height: 100%; }
.tsf__bar-fill--green { background: #10b981; }
.tsf__bar-fill--amber { background: #f0a500; }
.tsf__bar-fill--red { background: #e84545; }
.tsf__check { color: #3b82f6; font-size: 18px; flex-shrink: 0; }
</style>